import { render, staticRenderFns } from "./TransferTree.vue?vue&type=template&id=f460bf4a&scoped=true&"
import script from "./TransferTree.vue?vue&type=script&lang=js&"
export * from "./TransferTree.vue?vue&type=script&lang=js&"
import style0 from "./TransferTree.vue?vue&type=style&index=0&id=f460bf4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f460bf4a",
  null
  
)

export default component.exports